<svg
  class="play"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [ngStyle]="overrideStyle"
>
  <path
    d="M5.08057 12.7316C5.08057 13.1509 5.56553 13.384 5.89291 13.122L11.3425 8.76236C11.5927 8.56219 11.5927 8.18165 11.3425 7.98149L5.89291 3.6218C5.56553 3.3599 5.08057 3.59298 5.08057 4.01224V12.7316Z"
    fill="white"
  />
</svg>
